import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './ContactPage.css';

const links = [
  { label: 'Home', href: '/' },
  { label: 'Stay', href: '/stay' },
  { label: 'Explore', href: '/explore' },
  { label: 'Our story', href: '/our-story' },
  { label: 'Contact', href: '/contact' },
];

export default function ContactPage() {
  const [deliveryNotice, setDeliveryNotice] = useState('');

  function handleSubmit(event) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const subject = `Stay enquiry: ${data.get('property')}`;
    const body = `${data.get('message')}\n\nName: ${data.get('name')}\nEmail: ${data.get('email')}\nTravel dates: ${data.get('travelDates')}`;
    window.location.href = `mailto:support@jamrockescape.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setDeliveryNotice('Your email app will open with your enquiry. Send it there to contact support@jamrockescape.com.');
  }

  return (
    <>
      <Header homeHref="/" links={links} />
      <main id="main-content" className="contact-page" tabIndex={-1}>
        <section className="contact-page__layout" aria-labelledby="contact-title">
          <div className="contact-page__intro">
            <p className="contact-page__eyebrow">LET’S TALK ABOUT YOUR STAY</p>
            <h1 id="contact-title">A warm welcome starts with hello.</h1>
            <p className="contact-page__description">Planning a getaway, a work trip or a longer stay? Tell us what you have in mind.</p>
            <figure className="contact-page__image">
              <img src={`${process.env.PUBLIC_URL}/images/bannerfull.jpg`} alt="Turquoise water beside a tropical beach shaded by palms" width="1536" height="1024" />
              <figcaption>YOUR NEXT ESCAPE</figcaption>
            </figure>
            <p className="contact-page__location">Valdosta, Georgia · St Mary, Jamaica</p>
            <p className="contact-page__availability">Email us at <a href="mailto:support@jamrockescape.com">support@jamrockescape.com</a>.</p>
          </div>
          <form className="contact-page__form" onSubmit={handleSubmit} aria-labelledby="contact-form-title" aria-describedby="contact-privacy">
            <h2 id="contact-form-title">Send your host a message</h2>
            <p className="contact-page__subtitle">We’d love to hear what you’re planning.</p>
            <div className="contact-page__field">
              <label htmlFor="contact-name">Your name</label>
              <input id="contact-name" name="name" autoComplete="name" placeholder="Full name" required maxLength={120} />
            </div>
            <div className="contact-page__field">
              <label htmlFor="contact-email">Email address</label>
              <input id="contact-email" name="email" type="email" autoComplete="email" placeholder="you@example.com" required maxLength={254} />
            </div>
            <div className="contact-page__field">
              <label htmlFor="contact-property">Property</label>
              <select id="contact-property" name="property" defaultValue="" required>
                <option value="" disabled>Choose a destination</option>
                <option>Valdosta, Georgia</option>
                <option>St Mary, Jamaica</option>
                <option>Hillsboro, Oregon</option>
              </select>
            </div>
            <div className="contact-page__field">
              <label htmlFor="contact-dates">Travel dates <span>(optional)</span></label>
              <input id="contact-dates" name="travelDates" placeholder="When are you thinking of visiting?" maxLength={200} />
            </div>
            <div className="contact-page__field">
              <label htmlFor="contact-message">Your message</label>
              <textarea id="contact-message" name="message" placeholder="Tell us about your plans or ask a question." rows={4} required maxLength={5000} />
            </div>
            <button className="contact-page__submit" type="submit">Send message <span aria-hidden="true">↗</span></button>
            <p id="contact-privacy" className="contact-page__privacy">Your details will be used to respond to this enquiry.</p>
            {deliveryNotice && <p className="contact-page__notice" role="alert">{deliveryNotice}</p>}
          </form>
        </section>
      </main>
      <Footer />
    </>
  );
}
